export default __webpack_public_path__ + "static/media/281.5a68ae06.gif";